import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
export var useInitialOrDefaultFieldValue = function useInitialOrDefaultFieldValue(fieldName, defaultInitialValue) {
  var _useField = useField(fieldName),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    helpers = _useField2[2];
  var _useFormikContext = useFormikContext(),
    initialValues = _useFormikContext.initialValues;
  var fieldValue = field.value;
  useEffect(function () {
    if (!fieldValue && fieldValue !== '') helpers.setValue(defaultInitialValue);
  }, [initialValues]);
};